var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_145_46)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_145_46",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_145_46",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_145_46",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD2UlEQVR4nO2cz2tcVRTHr40txoVCNVUQf5S0W+lCxNIKEjTYhUttrV0IbQnYRf+EybJUxjQkmfv93pchC38s3lboxpVEbak/scaENoXuCiZtUwrRNuotl3kto42aifPevbn3fOALw8zAzPly5sx95553lRIEQRAEQRAEQRA6J8uyHQCOkfyE5HcArpK8XWjRPVe89h7J/nV8RLrUarUHjTHvkPyKpO1EAL4keTDP8x7fcQQNgNdJXujU4FU0R3LQdzzBQfJhkpNdMPjvGW7q9Xqv7/iCoNFobCP5bbdNbtPXzWazT6VMo2XyXIkm3yslyZrNVrkoM5Pvy+ypqamHVGqwhJq8hpoNlRIkB6s2uU37VCrrZHZnCbdezSaxzgZwyKPJd3VAxQ6AMwEY/YWKvXdB/ya7P8U/jTHbVayg1SCygWhIxQpbnTYbSFZ/pGIFwPcBGf2NihW2esihGP2LihUAt3wb3KbfVKzQv7l/kYoVBmCuGE0xumtAanQ1UFYd1QBZR1cDyY99G9ymD1WssDXoYgNR1L2Oftc5822y+w5a6+dUzHAdE0glaFrFDsmDvo02xrylYifP856KZjn+STNJ7Bk6tNaveczmAZUSAIwHoxsqNer1eq+bHqrQ5LNJTio53DxcRfV6luTjKmWazWYfgHNlZnKyA46rlRE3F1dGTU62XPwbJF8tfub/1+CZ5FYXnZLneY/W+m03TdTJ5Xrx3mkA+2u12ibfcWwojDHbXfPHzWAUs9SLbvOg2EBYcK3O4rWh6HsXgiAIgiAIgiAIyUDyUQC7jTFHAZwCcNp14Ip26hUAvzq5x64v4m4+Kt4zQvKIMeal0dHRR3zHERzj4+NPug1bAE2Sl7rYuZt3d+e6vkmWZU+oFDHG7CJ5EsBPFTT97zacfiR5Isuy51XMkHyG5PHieJ7Szf2vNirJYa31ThULJPcC+DSECaXVMh3AZwDesNY+oDYaeZ5v0VofJnnet5lcu34wxrxLcrPaCLjsAHAxAOPsOuUOBHgz2AzXWr/odkUCMMp2SZ8DeEEFdizEMIDfAzDHdll/kBz1Xk7c9lFx1pyNWQDOuQMDfJn8Cskl3yawOrOvG2NertRk94HFZbBNTMta6z2VmDw2NvaY24EOIGjrSQtZlm0t3WgAHwQQrPUpAO+XbrTng6dsCALwcxVGL/sOlP51s3SjAVwOIFDrWfNVGD0WQKDWs0ZKN1pr/RTJawEEaz1paWJi4unSjW672edGAEFbDxctA5VPegKYKFYhK75NYHlaKWIcn5ycfLZSkwVBEARBEARBEARBEFSY3AGxCe9xx48GAgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.4122610e10036ace8bae12c743b020c5.svg";
export { ForwardRef as ReactComponent };